import Ajax from '@utils/ajax';

export default {
  index(options = {}) {
    return Ajax.get({
      url: `/user_possible_group_ideas`,
      ...options,
    });
  },
};
